import React, { Fragment, useEffect, useState } from 'react';
import { Formik } from 'formik';
import moment from 'moment';

import { BlockWrapper } from '../Preview';
import { generateCss, generateEvent } from "../../functions/sortableFunctions";

const Form = ({ block, ...props }: any) => {
    const [initialValues, setInitialValues] = useState({});
    const [fileFieldValues, setFileFieldValues] = useState({});
    const [fileTypeFields, setFileTypeFields] = useState({});

    useEffect(() => {
        if (block.data?.fields) {
            setInitialValues(block?.data?.fields)
        } else {
            if (block.data.staticData && (props?.builderPreview || props?.componentsPreview)) {
                setInitialValues(block.data.staticData);
            } else {
                generateEvent({
                    props: {
                        ...props,
                        block: block
                    },
                    event: "onLoad",
                    fileTypeFields: fileTypeFields,
                    fileFieldValues: fileFieldValues,
                    setFileFieldValues: setFileFieldValues,
                    setInitialValues: setInitialValues
                });
            }
        }
    }, (block?.data?.dependencies ? eval(block.data.dependencies) : []));

    const month: any = {
        1: "January",
        2: "Febuary",
        3: "March",
        4: "April",
        5: "May",
        6: "June",
        7: "July",
        8: "August",
        9: "September",
        10: "October",
        11: "November",
        12: "December"
    }

    return (
        <Fragment>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validate={(values: any) => {
                    const errors: any = {};
                    if (block?.data?.validations) {
                        for (let field in block?.data?.validations) {

                            const restrictions = Object.keys(block?.data?.validations[field]);
                            const validation = block?.data?.validations?.[field];
                            const value = values?.[field]?.toString()?.trim();

                            if (restrictions?.includes('minSelected') && values?.[field]?.length < validation?.minSelected?.value) {
                                errors[field] = validation?.minSelected?.message || `Select minimum ${validation?.minSelected?.value} options`;

                            } else if (restrictions.includes('maxSelected') && values?.[field].length > validation?.maxSelected?.value) {
                                errors[field] = validation?.maxSelected?.message || `Maximum ${validation?.maxSelected?.value} options can be selected`;

                            } else if (restrictions.includes('required') && (Array.isArray(values?.[field]) ? values?.[field]?.length == 0 : value == '')) {
                                errors[field] = validation?.required?.message || `Required`;

                            } else if (restrictions.includes('minLength') && value?.length < validation?.minLength?.value) {
                                errors[field] = validation?.minLength?.message || `Minimum ${validation?.minLength?.value} characters is required`;

                            } else if (restrictions.includes('maxLength') && value?.length > validation?.maxLength?.value) {
                                errors[field] = validation?.maxLength?.message || `Maximum ${validation?.maxLength?.value} characters is allowed`;

                            } else if (restrictions.includes('pattern') && !new RegExp(validation?.pattern?.value).test(value)) {
                                errors[field] = validation?.pattern?.message || "Value is not matching to requested format";

                            } else if (restrictions.includes("sameAs") && (values?.[field]?.toString()?.trim() ?? "") !== (values?.[validation.sameAs.field]?.toString()?.trim() ?? "")) {
                                errors[field] = validation.sameAs.message || "Values do not match";

                            } else if (restrictions.includes('min') && (
                                validation?.min?.type ?
                                    (validation?.min?.type == 'date' || validation?.min?.type == 'datetime-local') ?
                                        (new Date(values[field])?.getTime()) < (new Date(validation?.min?.value)?.getTime())
                                        :
                                            validation?.min?.type == 'time' ?
                                                (parseInt(values[field]?.split(":")[0]) < parseInt(validation?.min?.value?.split(":")[0])) ||
                                                (parseInt(values[field]?.split(":")[0]) == parseInt(validation?.min?.value?.split(":")[0])) &&
                                                (parseInt(values[field]?.split(":")?.[1]) < parseInt(validation?.min?.value?.split(":")?.[1]))
                                            :
                                                validation?.min?.type == 'month' ?
                                                    (parseInt(values[field]?.split("-")[0]) < parseInt(validation?.min?.value?.split("-")[0])) ||
                                                    (parseInt(values[field]?.split("-")[0]) == parseInt(validation?.min?.value?.split("-")[0])) &&
                                                    (parseInt(values[field]?.split("-")[1]) < parseInt(validation?.min?.value?.split("-")?.[1]))
                                                :
                                                    validation?.min?.type == 'week' ?
                                                        (parseInt(values[field]?.split("-")[0]) < parseInt(validation?.min?.value?.split("-")[0])) ||
                                                        (parseInt(values[field]?.split("-")[0]) == parseInt(validation?.min?.value?.split("-")[0])) &&
                                                        (parseInt(values[field]?.split("-")[1].slice(1)) < parseInt(validation?.min?.value?.split("-")?.[1]?.slice(1)))
                                                    :
                                                        false
                                :
                                    (values[field] < validation?.min?.value)
                            )) {
                                if (validation?.min?.type) {
                                    let type = validation?.min?.type;

                                    if (type == 'date') {
                                        errors[field] = validation?.min?.message || `Maximum value is ${moment.unix(new Date(validation?.min?.value)?.getTime())?.format('ll')}`;
                                    }
                                    else if (type == 'datetime-local') {
                                        errors[field] = validation?.min?.message || `Maximum value is ${moment.unix(new Date(validation?.min?.value)?.getTime())?.format('lll')}`;
                                    }
                                    else if (type == 'time') {
                                        errors[field] = validation?.min?.message || `Maximum value is ${validation?.min?.value}`;
                                    }
                                    else if (type == 'month') {
                                        errors[field] = validation?.min?.message || `Maximum value is ${month[parseInt(validation?.min?.value?.split("-")?.[1])]} ${validation?.min?.value?.split("-")?.[0]}`;
                                    }
                                    else if (type == 'week') {
                                        errors[field] = validation?.min?.message || `Maximum value is week ${parseInt(validation?.min?.value?.split("-")?.[1]?.slice(1))} of ${validation?.min?.value?.split("-")?.[0]}`;
                                    }
                                }
                                else {
                                    errors[field] = validation?.min?.message || `Maximum value is ${validation?.min?.value}`;
                                }

                            } else if (restrictions.includes('max') && (
                                validation?.max?.type ? (
                                    validation?.max?.type == 'date' || validation?.max?.type == 'datetime-local') ?
                                        (new Date(values[field]).getTime()) > (new Date(validation?.max?.value)?.getTime())
                                    :
                                        validation?.max?.type == 'time' ?
                                            (parseInt(values[field].split(":")[0]) > parseInt(validation?.max?.value?.split(":")[0])) ||
                                            (parseInt(values[field]?.split(":")[0]) == parseInt(validation?.max?.value?.split(":")[0])) &&
                                            (parseInt(values[field]?.split(":")[1]) > parseInt(validation?.max?.value?.split(":")?.[1]))
                                        :
                                            validation?.max?.type == 'month' ?
                                                (parseInt(values[field]?.split("-")[0]) > parseInt(validation?.max?.value?.split("-")[0])) ||
                                                (parseInt(values[field]?.split("-")[0]) == parseInt(validation?.max?.value?.split("-")[0])) &&
                                                (parseInt(values[field]?.split("-")[1]) > parseInt(validation?.max?.value?.split("-")?.[1]))
                                            :
                                                validation?.max?.type == 'week' ?
                                                    (parseInt(values[field]?.split("-")[0]) > parseInt(validation?.max?.value?.split("-")[0])) ||
                                                    (parseInt(values[field]?.split("-")[0]) == parseInt(validation?.max?.value?.split("-")[0])) &&
                                                    (parseInt(values[field]?.split("-")[1]?.slice(1)) > parseInt(validation?.max?.value?.split("-")?.[1]?.slice(1)))
                                                :
                                                    false
                                :
                                    (values[field] > validation?.max?.value)
                            )) {
                                if (validation?.max?.type) {
                                    if (validation?.max?.type == 'date') {
                                        errors[field] = validation?.max?.message || `Maximum value is ${moment.unix(new Date(validation?.max?.value)?.getTime())?.format('ll')}`;
                                    }
                                    else if (validation?.max?.type == 'datetime-local') {
                                        errors[field] = validation?.max?.message || `Maximum value is ${moment.unix(new Date(validation?.max?.value)?.getTime())?.format('lll')}`;
                                    }
                                    else if (validation?.max?.type == 'time') {
                                        errors[field] = validation?.max?.message || `Maximum value is ${validation?.max?.value}`;
                                    }
                                    else if (validation?.max?.type == 'month') {
                                        errors[field] = validation?.max?.message || `Maximum value is ${month[parseInt(validation?.max?.value?.split("-")[1])]} ${validation?.max?.value?.split("-")[0]}`;
                                    }
                                    else if (validation?.max?.type == 'week') {
                                        errors[field] = validation?.max?.message || `Maximum value is week ${parseInt(validation?.max?.value?.split("-")[1]?.slice(1))} of ${validation?.max?.value?.split("-")[0]}`;
                                    }
                                }
                                else {
                                    errors[field] = validation?.max?.message || `Maximum value is ${validation?.max?.value}`;
                                }

                            } else if (restrictions.includes('acceptedFormats') && (Array.from(values[field])?.map((value: any) => {
                                let match = false;

                                for (let j = 0; j < validation?.acceptedFormats?.value?.length; j++) {
                                    if (validation?.acceptedFormats?.value[j].includes('*')) {
                                        if (value.type.includes(validation?.acceptedFormats?.value[j]?.split('/')[0])) {
                                            match = true;
                                            break;
                                        }
                                    } else {
                                        if (value.type == validation?.acceptedFormats?.value[j]) {
                                            match = true;
                                            break;
                                        }
                                    }
                                }

                                return match;
                            }).includes(false))) {
                                errors[field] = validation?.acceptedFormats?.message || `File format not matching requested formats`;

                            } else if (restrictions.includes('minFileSize') && (Array.from(values[field])?.map((value: any) => {
                                return (value.size < (validation?.minFileSize?.value * (validation?.maxFileSize?.unit == 'mb' ? 1048576 : validation?.maxFileSize?.unit == 'gb' ? 1073741824 : 1024)));
                            }).includes(true))) {
                                errors[field] = validation?.minFileSize?.message || `File should be of minimum ${validation?.minFileSize.value}${validation?.minFileSize.unit}`;

                            } else if (restrictions.includes('maxFileSize') && (Array.from(values[field])?.map((value: any) => {
                                return (value.size > (validation?.maxFileSize?.value * (validation?.maxFileSize?.unit == 'mb' ? 1048576 : validation?.maxFileSize?.unit == 'gb' ? 1073741824 : 1024)));
                            }).includes(true))) {
                                errors[field] = validation?.maxFileSize.message || `File should be of maximum ${validation?.maxFileSize?.value}${validation?.maxFileSize?.unit}`;
                            }
                        }
                    }
                    return errors;
                }}
                onSubmit={async (values, { setSubmitting, resetForm }) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        event: "onSubmit",
                        resetForm: resetForm,
                        values: values,
                        setSubmitting: setSubmitting,
                        fileTypeFields: fileTypeFields,
                        fileFieldValues: fileFieldValues,
                        setFileFieldValues: setFileFieldValues
                    });
                }}
            >
                {
                    (formik) => (
                        <form
                            id={block.id}
                            onSubmit={formik.handleSubmit}
                            className={generateCss({
                                props: {
                                    ...props,
                                    block: block
                                }
                            })}
                            style={{
                                fontFamily: block?.style?.fontFamily
                            }}
                        >
                            {
                                block.children.map((value: any, index: any) => {
                                    return (
                                        <BlockWrapper
                                            {...props}
                                            block={value}
                                            formik={formik}
                                            key={index}
                                            fileFieldValues={fileFieldValues}
                                            setFileFieldValue={setFileFieldValues}
                                            setFileTypeFields={setFileTypeFields}
                                        />
                                    )
                                })
                            }
                        </form>
                    )
                }
            </Formik>
        </Fragment>
    )
}

export default Form;